export default __webpack_public_path__ + "static/media/check-mark.9746ea22.svg";